"use client";

import { useEffect } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Shared modal wrapper voor CTA's die een form openen — bv. Adv3DBlock
 * (3D-ontwerp afspraak) en AdvisorCTA (telefonisch adviesgesprek).
 *
 * Klik op overlay sluit, klik op kaart blokkeert bubbling. ESC-toets
 * sluit ook. Body scroll-lock zolang modal open is.
 */
export default function CtaModal({ open, onClose, children }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(20,28,40,0.55)",
        display: "grid",
        placeItems: "center",
        padding: 8,
        zIndex: 10000,
        overflowY: "auto",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <style>{`
        @media (max-width: 480px) {
          .bw-cta-modal-card { padding: 24px 18px !important; border-radius: 12px !important; }
        }
      `}</style>
      <div
        className="bw-cta-modal-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          background: "#FFFFFF",
          borderRadius: 16,
          width: "100%",
          maxWidth: 760,
          padding: "36px 32px",
          boxShadow: "0 24px 60px rgba(0,0,0,0.3)",
          maxHeight: "94vh",
          overflowY: "auto",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Sluiten"
          style={{
            position: "absolute",
            top: 10,
            right: 12,
            width: 36,
            height: 36,
            border: "none",
            background: "transparent",
            fontSize: 28,
            lineHeight: 1,
            cursor: "pointer",
            color: "#5A6578",
            zIndex: 1,
          }}
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
